<template>
  <template v-if="!isSellEnded">
    <div class="add-to-cart" data-vue-add-to-cart>
      <input
        v-if="showqty && shopAllowQtyModification"
        type="number"
        v-model="qtyIncr"
        min="1"
        step="1"
      />
      <button
        type="button"
        class="add-to-cart-btn"
        @click.prevent="(event) => addToCartAction(event)"
      >
        {{ btnlabel ? btnlabel : $t("labels.addToCart") }}
      </button>
    </div>
  </template>
  <template v-else>
    <div class="add-to-cart-ended">
      {{ $t("labels.sellEnded") }}
    </div>
  </template>
</template>

<script>
import CartService from "@/services/cart";
import { useDraftStore } from "@/store/draft";
import ProductService from "@/services/product";
import FetchFile from "@/services/fetchFile";
import { useCartStore } from '@/store/cart'

export default {
  name: "AddToCart",
  props: {
    item: Object,
    showqty: Boolean,
    changeChoice: Object,
    btnlabel: String,
    isfromstaticpage: Boolean,
    productexternalid: String,
    choiceexternalid: String,
    productinfos: String,
  },
  data() {
    return {
      productDetails: {},
      isSellEnded: false,
      intervalSellEnded: null,
      shopAllowQtyModification: false,
      qtyIncr: 1,
    };
  },
  mounted() {
    if (!this.isfromstaticpage) {
      this.productDetails = window.productDetails;
      if (this.productDetails?.endDate) {
        this.isSellEnded = this.productDetails.endDate <= Date.now();
        this.intervalSellEnded = setInterval(() => {
          this.isSellEnded = this.productDetails.endDate <= Date.now();
        }, 1000);
      }
      this.shopAllowQtyModification =
        !!window.globalConfig.shopAllowQtyModification;
    }
  },
  beforeDestroy() {
    if (this.intervalSellEnded) {
      clearInterval(this.intervalSellEnded);
    }
  },
  methods: {
    async addToCartAction(event) {
      if (this.productDetails && this.productDetails.limitCartTo1Item) {
        if (
          useCartStore().cart.items.length > 0
        ) {
          CartService.emptyCart();
        }
      }

      if (this.item) {
        // product list
        this.item.qtyIncr = this.qtyIncr;
        if (this.changeChoice) {
          this.item.qty = 0; // change of choice, reset qty
          this.item.choice = this.changeChoice;
        } else {
          this.item.choice = ProductService.getDefaultChoice(this.item);
        }
        CartService.addToCart(this.item);
      } else if (this.productDetails) {
        // product view
        if (this.isfromstaticpage) {
          await this.getProductDetails();
          console.log('this.productDetails', this.productDetails);
        }

        const productToAdd = Object.assign({}, this.productDetails);
        productToAdd.qtyIncr = this.qtyIncr;
        const selectedChoiceId = useDraftStore().selectedChoice;

        if (selectedChoiceId) {
          productToAdd.choice = this.productDetails.choices.find(
            (choice) => choice.id === selectedChoiceId,
          );

          CartService.addToCart(productToAdd);
        } else {
          console.error("You need to choose a choice");
        }
      }
    },
    async getProductDetails() {
      const productExternalId = this.productexternalid || window.productExternalId;
      const choiceExternalId = this.choiceexternalid || window.choiceExternalId;
      const productInfos = this.productinfos || window.productInfos;
      const data = await new Promise((resolve, reject) => {
        new FetchFile().fetch(`/data/products/${productExternalId}.json`, ({ data }) => {
          resolve(data);
        }, reject);
      });

      this.productDetails = data;
      this.productDetails.choices.forEach((choice) => {
        if (choice.id === choiceExternalId) {
          useDraftStore().selectChoice(choice.id);
        }
      });
      if (productInfos) {
        this.productDetails.productInfos = productInfos
      }
    },
  },
};
</script>
